module.exports = __webpack_public_path__ + "1569aca0cb46b2ca655c964006c337de.svg";